"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Image = exports.Content = exports.Container = exports.ButtonsContainer = exports.Button = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
background-color: ${props => props.background ? props.background : 'white'};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.Container = Container;
const Content = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  ${(0, _layout.setContainer)({
  size: 'md'
})}
`;
exports.Content = Content;
const Image = _styledComponents.default.img`
  width: 100px;
  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    width: 126px;
  }
  @media (min-width: ${_breakpoints.BREAKPOINTS.md}px) {
    width: 152px;
  }
`;
exports.Image = Image;
const Title = _styledComponents.default.h3`
  color: ${props => props.colorMode === 'dark' ? 'white' : 'inherit'};
  font-family: 'univers-cond', sans-serif;
  line-height: 35.2px;
  ${(0, _typography.setFontSizes)({
  xs: '24px',
  sm: '32px'
})}
  margin: 32px 0;
`;
exports.Title = Title;
const ButtonsContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    flex-direction: row;
  }

  button {
    background-color: ${props => props.colorMode === 'dark' ? 'white' : 'black'};
    color: ${props => props.colorMode === 'dark' ? 'black' : 'white'};
    min-width: 125px;
  }
`;
exports.ButtonsContainer = ButtonsContainer;
const Button = _styledComponents.default.button`
  font-family: 'univers-black', sans-serif;
  padding: 15px 20px;
  width: 100%;
  border: 0;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  line-height: 15.4px;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${(0, _typography.setFontSizes)({
  xs: '14px'
})}

  & + button {
    margin-top: 15px;
  }

  @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
    width: initial;

    & + button {
      margin-top: 0;
      margin-left: 25px;
    }
  }
`;
exports.Button = Button;
//# sourceMappingURL=styles.js.map